(function () {
  const PRODUCT_MAPS = {
    y813: {
      handles: [
        'realwriter-y813-thermal-printer-white',
        'realwriter-y813-thermal-printer-black',
        'realwriter-y813-thermal-printer-pink',
      ],
      colors: {
        white: 'realwriter-y813-thermal-printer-white',
        black: 'realwriter-y813-thermal-printer-black',
        pink: 'realwriter-y813-thermal-printer-pink',
      },
    },
    y41bt: {
      handles: [
        'knaon-bluetooth-thermal-printer-y41bt-white',
        'knaon-bluetooth-thermal-printer-y41bt-black',
      ],
      colors: {
        white: 'knaon-bluetooth-thermal-printer-y41bt-white',
        black: 'knaon-bluetooth-thermal-printer-y41bt-black',
      },
    },
  };

  function getLangPrefix() {
    const match = window.location.pathname.match(/^\/([\w-]{2,5})\//);
    const excluded = ['products', 'collections', 'pages', 'blogs', 'cart'];
    if (match && !excluded.includes(match[1])) {
      return '/' + match[1];
    }
    return '';
  }

  function getCurrentProductMap() {
    const pathname = window.location.pathname;

    return Object.values(PRODUCT_MAPS).find((product) =>
      product.handles.some((handle) => pathname.endsWith('/products/' + handle))
    );
  }

  function init() {
    const swatches = document.querySelectorAll('input[type="radio"][name="Color"]');
    swatches.forEach((el) => {
      el.addEventListener('change', handleChange);
    });
  }

  function handleChange(e) {
    const productMap = getCurrentProductMap();
    if (!productMap) return;

    const value = e.target.value.toLowerCase();
    const handle = productMap.colors[value];

    if (handle && !window.location.pathname.endsWith('/products/' + handle)) {
      window.location.href = getLangPrefix() + '/products/' + handle;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();